import { jsx as _jsx } from "react/jsx-runtime";
import { EnvelopeIcon } from '@heroicons/react/24/outline';
import ChatTab from '@web/components/Apps/Chat';
import { DriveTab } from '@web/components/Apps/Drive/index';
import { DriveAdvancedSearch } from '@web/components/Apps/DriveAdvancedSearch';
import { GeminiTab } from '@web/components/Apps/Gemini/index';
import { GmailTab } from '@web/components/Apps/Gmail/index';
import { MeetTab } from '@web/components/Apps/Meet/index';
import SearchMeetingsTab from '@web/components/Apps/SearchMeetings/index';
import Loading from '@web/components/layout/Loading';
import Tabs from '@web/components/layout/Tabs';
import Events from '@web/components/Settings/Events/Events';
import EventLogIcon from '@web/components/ui/icons/EventLogIcon';
import GeminiIcon from '@web/components/ui/icons/GeminiIcon';
import GoogleChatIcon from '@web/components/ui/icons/GoogleChatIcon';
import GoogleDriveIcon from '@web/components/ui/icons/GoogleDriveIcon';
import GoogleMeetIcon from '@web/components/ui/icons/GoogleMeetIcon';
import SearchDriveIcon from '@web/components/ui/icons/SearchDriveIcon';
import SearchMeetIcon from '@web/components/ui/icons/SearchMeetIcon';
import { useWorkspaceCtx } from '@web/contexts/Workspace';
import { appsUrl } from '@web/router/urls';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { usePageTitle } from '@web/utility/hooks/usePageTitle';
import { appsActiveTabs } from '@web/utility/tabs';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
export var Apps = function () {
    var _a;
    var navigateTo = useNavigateTo();
    var isLoading = useWorkspaceCtx().isLoading;
    var _b = useParams().activeTab, activeTab = _b === void 0 ? appsActiveTabs.gmail : _b;
    var t = useTranslation().t;
    var tabs = [
        {
            name: t('app.apps.gmail.title'),
            id: appsActiveTabs.gmail,
            icon: _jsx(EnvelopeIcon, { className: "w-5 h-5 inline-block" }),
            Component: GmailTab
        },
        {
            name: t('app.apps.drive.title'),
            id: appsActiveTabs.drive,
            icon: _jsx(GoogleDriveIcon, {}),
            Component: DriveTab
        },
        {
            name: t('app.apps.meeting.title'),
            id: appsActiveTabs.meet,
            icon: _jsx(GoogleMeetIcon, {}),
            Component: MeetTab
        },
        {
            name: t('app.apps.chat.title'),
            id: appsActiveTabs.chat,
            icon: _jsx(GoogleChatIcon, {}),
            Component: ChatTab
        },
        {
            name: t('app.apps.gemini.title'),
            id: appsActiveTabs.gemini,
            icon: _jsx(GeminiIcon, {}),
            Component: GeminiTab
        },
        {
            name: t('app.driveAdvancedSearch.title'),
            id: appsActiveTabs.driveAdvancedSearch,
            icon: _jsx(SearchDriveIcon, {}),
            Component: DriveAdvancedSearch
        },
        {
            name: t('app.apps.searchMeetings.title'),
            id: appsActiveTabs.searchMeetings,
            icon: _jsx(SearchMeetIcon, {}),
            Component: SearchMeetingsTab
        },
        {
            name: t('eventsLog.title'),
            id: appsActiveTabs.eventsLog,
            icon: _jsx(EventLogIcon, { className: "w-5 h-5 inline-block" }),
            Component: Events
        }
    ];
    var activeTabTitle = (_a = tabs.find(function (tab) { return tab.id === activeTab; })) === null || _a === void 0 ? void 0 : _a.name;
    usePageTitle("Apps / ".concat(activeTabTitle));
    if (isLoading) {
        return _jsx(Loading, {});
    }
    function onChange(id) {
        navigateTo({ pathname: "".concat(appsUrl, "/").concat(id) });
    }
    return _jsx(Tabs, { active: activeTab, tabs: tabs, onChange: onChange });
};
